(function () {
  "use strict";

  if (window.__vendmontFreeToolsBound) return;
  window.__vendmontFreeToolsBound = true;

  var channel = "vendmont-free-tool";
  var minimumHeight = 640;
  var maximumHeight = 16000;
  var allowedInternalPaths = new Set([
    "/",
    "/pages/tools",
    "/pages/digital-zone",
  ]);

  function matchingFrame(eventSource, tool) {
    var frames = document.querySelectorAll("[data-vendmont-free-tool-frame]");

    for (var index = 0; index < frames.length; index += 1) {
      var frame = frames[index];
      if (
        frame.contentWindow === eventSource &&
        frame.dataset.vendmontTool === tool
      ) {
        return frame;
      }
    }

    return null;
  }

  function safeInternalPath(href) {
    if (typeof href !== "string" || href.charAt(0) !== "/") return null;
    if (href.slice(0, 2) === "//") return null;

    try {
      var destination = new URL(href, window.location.origin);
      if (destination.origin !== window.location.origin) return null;
      if (!allowedInternalPaths.has(destination.pathname)) return null;
      return destination.href;
    } catch (error) {
      return null;
    }
  }

  window.addEventListener("message", function (event) {
    var data = event.data;
    if (
      !data ||
      data.channel !== channel ||
      typeof data.tool !== "string"
    ) {
      return;
    }

    var frame = matchingFrame(event.source, data.tool);
    if (!frame) return;

    if (data.type === "height") {
      var requestedHeight = Number(data.height);
      if (!Number.isFinite(requestedHeight)) return;

      var nextHeight = Math.min(
        maximumHeight,
        Math.max(minimumHeight, Math.ceil(requestedHeight)),
      );
      frame.style.height = nextHeight + "px";
      frame.dataset.vendmontReady = "true";
      return;
    }

    if (data.type !== "navigate") return;

    var internalDestination = safeInternalPath(data.href);
    if (internalDestination) {
      window.location.assign(internalDestination);
      return;
    }

    if (
      typeof data.href === "string" &&
      data.href.toLowerCase() === "mailto:info@vendmont.com"
    ) {
      window.location.href = data.href;
    }
  });
})();
